




















import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';

@Component
export default class ClientUnitDeliveryRoutes extends BaseComponent {
  
  @Prop()
  public data: any[];
  
  public headersDeliveryRoutes: any = [
    { text: 'Código da Rota', value: 'codigoRota', sortable: true },
    { text: 'Descrição', value: 'descricao', sortable: true },
    { text: 'Horário Máximo de Prescrição', value: 'horarioMaxPrescricao', sortable: true },
    { text: 'Horário de Saída', value: 'horarioSaida', sortable: true },
    { text: 'Horário de Entrega', value: 'horarioEntrega', sortable: true },
  ];    
}
